import { useEffect, useRef, useState } from 'react';

export const useStuckState = () => {
  const [stuck, setIsStuck] = useState<boolean>(false);
  const buttonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    /**
     * Хендлер, необходимый для удаления фона кнопки, когда она переходит в position:static
     * */
    const stuckObserver = new IntersectionObserver(
      entries =>
        entries.forEach(entry => {
          if (entry.intersectionRatio === 1) {
            setIsStuck(true);
          } else {
            setIsStuck(false);
          }
        }),
      { threshold: 1 },
    );

    stuckObserver.observe(buttonRef.current as Element);

    return () => {
      stuckObserver.disconnect();
    };
  }, []);

  return {
    stuck,
    buttonRef,
  };
};
